import { useParams, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import LeadInfoCard from './LeadInfoCard'
import CommunicationPanel from './CommunicationPanel'
import useLeadDetails from '../list/hooks/useLeadDetails'
import Loading from '@/widgets/Loading.jsx'

export default function LeadDetails() {
	const { id } = useParams()
	const navigate = useNavigate()
	const { lead, loading, error, deleting, deleteLead, newNote, setNewNote, addingNote, addNote, fetchLead } = useLeadDetails(id)
	// console.log(`TCL -> index.jsx:12 -> LeadDetails -> lead:`, lead)

	const handleEdit = useCallback(() => {
		if (!lead?._id) return
		navigate(`/leads/edit/${lead._id}`)
	}, [navigate, lead?._id])

	if (loading) return <Loading />
	if (error) return <div>Error: {String(error)}</div>
	if (!lead) return <div>No data</div>

	return (
		<div className="grid grid-cols-1 gap-4 xl:gap-8 lg:grid-cols-2 xl:grid-cols-3">
			<div className="flex lg:col-span-1">
				<LeadInfoCard lead={lead} onEdit={handleEdit} onDelete={deleteLead} deleting={deleting} onStatusUpdate={fetchLead} />
			</div>

			<div className="flex lg:col-span-1 xl:col-span-2">
				<CommunicationPanel
					communications={lead.communications || []}
					newNote={newNote}
					setNewNote={setNewNote}
					addingNote={addingNote}
					onAddNote={addNote}
				/>
			</div>
		</div>
	)
}
